import { OFFRE_REDUCER_NAME } from '../offre';
import { OfferStateType } from '../offre/types';

export const cachedDepartmentsSelector = (s: OfferStateType) =>
    s[OFFRE_REDUCER_NAME].cached.departments;
